import * as React from 'react';
import { connect } from 'react-redux';
import * as Types from '../../types';

interface Props {
  authenticationType: Types.AuthenticationType | null;
  children: React.ReactNode;
  authTypes: Types.AuthenticationType[];
}

const isRequiredAuthentication = (
  authenticationType: Types.AuthenticationType,
  requiredAuthTypes: Types.AuthenticationType[],
): boolean => {
  return requiredAuthTypes.some(
    (requiredAuthType) => requiredAuthType === authenticationType,
  );
};

const Component: React.FC<Props> = (props) => {
  if (
    !props.authenticationType ||
    !isRequiredAuthentication(props.authenticationType, props.authTypes)
  ) {
    return null;
  }

  return <>{props.children}</>;
};

const mapStateToProps = ({ organisation: { organisation } }: Types.State) => ({
  authenticationType: organisation?.authenticationType ?? null,
});

export const RequiredAuthType = connect(mapStateToProps)(Component);
